// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3NghS","label":"LabeledBox_label__3gq58"};